import React from "react";

export default function AddUserPage() {
  return (
    <div>
      <h1>Add User</h1>
      <p>Add a new user here.</p>
    </div>
  );
}